import { render, staticRenderFns } from "./EditInfoCardSecond.vue?vue&type=template&id=9497c20e"
import script from "./EditInfoCardSecond.vue?vue&type=script&lang=js"
export * from "./EditInfoCardSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports